export const BACKEND_CONTENT_TYPE = {
    8:"contracts",
    12:"profile",
    14:"trips",
    20:"orders"


}